module.exports = __webpack_public_path__ + "static/img/invest-consume5.1090b89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume5.jpg
// module id = Fhpb
// module chunks = 0